/// <reference path='./graphql.d.ts' />

import getGlossData from './getGlossData.gql';
import getGlossVersion from './getGlossVersion.gql';

export const getGlossDataQuery = getGlossData;
export const getGlossVersionQuery = getGlossVersion;
